export var VoiceCallModel;
(function (VoiceCallModel) {
    // OpenAI models
    VoiceCallModel["gpt_4o"] = "gpt-4o";
    VoiceCallModel["gpt_4o_2024_11_20"] = "gpt-4o-2024-11-20";
    VoiceCallModel["gpt_4o_mini"] = "gpt-4o-mini";
    VoiceCallModel["gpt_4o_realtime_cluster"] = "gpt-realtime-2025-08-28";
    VoiceCallModel["gpt_4o_realtime_preview"] = "gpt-4o-realtime-preview-2024-12-17";
    VoiceCallModel["gpt_4o_mini_realtime_preview"] = "gpt-4o-mini-realtime-preview-2024-12-17";
    VoiceCallModel["gpt_4_1"] = "gpt-4.1";
    VoiceCallModel["gpt_4_1_mini"] = "gpt-4.1-mini";
    VoiceCallModel["gpt_5"] = "gpt-5";
    VoiceCallModel["gpt_5_mini"] = "gpt-5-mini";
    VoiceCallModel["gpt_5_nano"] = "gpt-5-nano";
    VoiceCallModel["gpt_5_chat"] = "gpt-5-chat-latest";
    VoiceCallModel["gpt_5_1"] = "gpt-5.1";
    VoiceCallModel["gpt_5_2"] = "gpt-5.2";
    VoiceCallModel["gpt_5_1_chat"] = "gpt-5.1-chat-latest";
    VoiceCallModel["gpt_5_2_chat"] = "gpt-5.2-chat-latest";
    // Anthropic models
    VoiceCallModel["claude_3_5_sonnet"] = "claude-3-5-sonnet-20240620";
    VoiceCallModel["claude_3_7_sonnet"] = "claude-3-7-sonnet-20250219";
    VoiceCallModel["claude_opus_4"] = "claude-opus-4-20250514";
    VoiceCallModel["claude_opus_4_5"] = "claude-opus-4-5-20251101";
    VoiceCallModel["claude_opus_4_6"] = "claude-opus-4-6";
    VoiceCallModel["claude_sonnet_4"] = "claude-sonnet-4-20250514";
    VoiceCallModel["claude_sonnet_4_5"] = "claude-sonnet-4-5-20250929";
    VoiceCallModel["claude_sonnet_4_6"] = "claude-sonnet-4-6";
    VoiceCallModel["claude_haiku_4_5"] = "claude-haiku-4-5-20251001";
    // Notable proxy
    VoiceCallModel["notable_gpt_4o"] = "notable-gpt-4o";
})(VoiceCallModel || (VoiceCallModel = {}));
//# sourceMappingURL=model.js.map